import {Component, Inject, Input} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { IProdutos } from '../../../../models/produtos.model';
import { VerMaisDialog } from '../ver-mais/ver-mais.dialog';

@Component({
    selector: 'produto-detail-dialog',
    templateUrl: 'produto-detail-dialog.html',
    styleUrls:['produto-detail-dialog.scss']
  })
  export class ProdutoDetailDialog {
    innerValue:number=1;
    produto:IProdutos;
  
    get qtde():number{
       return this.innerValue;
    };
    set qtde(x){
      if (x<this.produto.qtdeMin) x=this.produto.qtdeMin;
      if (x>this.produto.qtdeMax) x = this.produto.qtdeMax;
      this.innerValue = x;
    }

    constructor(
      public dialogRef: MatDialogRef<VerMaisDialog>,
      public dialog: MatDialog,
      @Inject(MAT_DIALOG_DATA) public data: any) {
        this.produto = data;
        if (data.qtde!=null)
           this.qtde = data.qtde;
       }
    onNoClick(): void {
      this.dialogRef.close(null);
    }
    onOkClick(){
      this.dialogRef.close(this.qtde);
    }
    alterarQtde(x){
      console.log(x);
      this.qtde = x;
    }
    espefMax = 250;
    getEspecificacao(produto){
      return produto.especificacao.substring(0,this.espefMax);
    }
    temMais(){
      if (!this.produto.especificacao)
         this.produto.especificacao = '';
      try {
        return this.produto.especificacao.length>this.espefMax;
      } catch( err) {
        return false;
      }
    }
    getTitulo(produto){
      return produto.nome.substring(0,60);
    }
    verEspecificacao(){

        let dados={title:"Detalhes",text:this.produto.especificacao};
        let dialogRef = this.dialog.open(VerMaisDialog, {
          maxWidth: "90%",
          minWidth: "70%",
          data : dados});   
        
    
        dialogRef.afterClosed().subscribe(result => {
        });
      }
    

  }